import { useIntl } from "react-intl";

import { RanaTable } from "@nens/ranalib";

import { TableEmptyHistory } from "@/components/table-empty-history";

import { UseEventsListProps, useEventsList } from "./hook/use-event-list";

export function EventsList(props: UseEventsListProps) {
  const intl = useIntl();

  const { events, getRowAndLinkProps, isLoading } = useEventsList({
    initialPageSize: 20,
    ...props,
  });
  return (
    <RanaTable
      emptyElement={<TableEmptyHistory />}
      columnDefinitions={[
        {
          width: "table_cell_xxs",
          title: intl.formatMessage({
            id: "title.message",
            defaultMessage: "Message",
          }),
        },
      ]}
      tableDataIds={events.map(({ id }) => id + "")}
      isSkeleton={isLoading}
    >
      <RanaTable.Container borderWidth={0} minH="full">
        <RanaTable.Body>
          {events.map((event) => {
            const { id, message } = event;
            const { disabledText, to, queryParams } = getRowAndLinkProps(event);

            return (
              <RanaTable.Row
                isDisabled={!!disabledText}
                title={disabledText}
                rowId={id + ""}
                key={id}
                to={to}
                queryParams={queryParams}
              >
                <RanaTable.Cell title={message}>{message}</RanaTable.Cell>
              </RanaTable.Row>
            );
          })}
        </RanaTable.Body>
      </RanaTable.Container>
    </RanaTable>
  );
}
